var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg128Straight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.812,0,92.616-12.757,132.462-36.893 c9.447-5.722,12.467-18.021,6.744-27.468c-5.724-9.449-18.022-12.468-27.469-6.745C334.143,461.244,295.504,472,256,472 c-119.103,0-216-96.897-216-216S136.897,40,256,40s216,96.897,216,216c0,42.589-12.665,84.044-36.626,119.885 c-6.139,9.182-3.672,21.603,5.51,27.742c9.184,6.14,21.604,3.671,27.742-5.511C497.002,355.674,512,306.531,512,256 C512,187.62,485.371,123.333,437.02,74.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,303H196c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h120c11.046,0,20-8.954,20-20 C336,311.954,327.046,303,316,303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,151c-27.57,0-50,22.43-50,50c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20c0-5.514,4.486-10,10-10 c5.514,0,10,4.486,10,10c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20C395,173.43,372.57,151,345,151z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,151c-27.57,0-50,22.43-50,50c0,11.046,8.954,20,20,20s20-8.954,20-20c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10 c0,11.046,8.954,20,20,20s20-8.954,20-20C218,173.43,195.57,151,168,151z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg128Straight);
export default __webpack_public_path__ + "static/media/128-straight.69e228a6e210cc070ac75a1c13f17d03.svg";
export { ForwardRef as ReactComponent };